import React from 'react';
import './loader.scss'
const Loader = () => {
    return (
        <>
            <div className="holder">
                <div className="preloader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    );
};

export default Loader;